import { YouTube as YouTubeIcon } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import {
  Avatar,
  Badge,
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Link,
  List,
  ListItem,
  ListItemAvatar,
  ListItemButton,
  ListItemText,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { styled, useTheme } from '@mui/material/styles';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Config } from 'src/config';
import HttpServices from 'src/services/httpService';
import { integrateModuleURL } from 'src/services/urlService';
import { CommonHelper } from 'src/utils/commonHelper';
import { useToaster } from 'src/utils/toaster/toasterContext';
import instagram from '../../../assets/instagram.svg';
import CustomDomainRedirectIframe from '../customDomainIframe';
import LoadFacebookSdk from '../loadFacebookSdk';
import ThreeDotLoader from 'src/utils/Loader/threeDotLoader.compontent';
import InstagramAuthorizationModal from './instagramAuthorizationModal';
import { useResellerLimitDialog } from 'src/components/reseller-limit-context/resellerLimitContext';


const InstagramIntegration = (props) => {
  const { t: translate } = useTranslation();
  const theme = useTheme();
  const { showResellerLimitDialog } = useResellerLimitDialog();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [isAuthorizationModalOpen, setAuthorizationModal] = useState(true);
  const [isNoAccountForIntegrate, setNoAccountIntegrated] = useState(false);
  const [isInstaAccountModalOpen, setInstaAccountModal] = useState(false);
  const [accounts, setAccounts] = useState([]);
  const [profileId, setProfileId] = useState('');
  const [selectedPages, setSelectedPages] = useState([]);
  const [loaderReplies, setLoaderReplies] = useState(false);
  const [pagination, setPagination] = useState('');
  const [selectedAccounts, setSelectedAccounts] = useState([]);
  const [isLoadSdk, setLoadSdk] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const { showToast } = useToaster();
  let isProcessing = false;
  const isPortalAdmin = CommonHelper.GetBrandInfoFromLocalStorage("is_portal_admin");
  const isCustomDomain = CommonHelper.CustomDomain();  let intervalId = null;
  const messageListenerRef = useRef(null);

  useEffect(() => {
    intervalId = setInterval(() => {
      checkAuthoCodeReceivedFromFacebook();
    }, Config.Common.socialAccountsIntegrationInterval);
    return () => {
      clearInterval(intervalId);
      cleanupListener();
    };
  }, []);
  const instagramAccountSuccessCallback = (data, message) => {
    if (data.accounts && data.accounts.length > 0) {
      let isNoAccountForIntegrate = !data.accounts.some((a) => !a.is_integrated);
      setNoAccountIntegrated(isNoAccountForIntegrate);
    }
    setAuthorizationModal(false);
    setInstaAccountModal(true);
    setLoading(false);
    setAccounts(data.accounts);
    setProfileId(data.id);
    setPagination(data.pagination);
  };
  const fbNextPagesSuccessCallback = (data, message) => {
    if (data.accounts && data.accounts && data.accounts.length > 0) {
      let newAccounts = data.accounts.filter(
        (newAccount) => !accounts.some((existingPage) => existingPage.id === newAccount.id)
      );
      let updatedPages = [...accounts, ...newAccounts];
      setAccounts(updatedPages);
      if (pagination && pagination != data.pagination) {
        setPagination(data.pagination);
      } else {
        setPagination('');
      }
    } else {
      setPagination('');
    }
    setLoaderReplies(false);
  };
  const fetchNextPagesFromServer = () => {
    setLoaderReplies(true);
    let form = {
      temp_connected_profile_id: profileId,
      pagination: pagination,
    };
    let postProps = {
      url: integrateModuleURL.fetchNextInstagramPagesAndGroups,
      body: form,
      successCallback: fbNextPagesSuccessCallback,
      failureCallback: instagramAccountFailureCallback,
    };
    HttpServices.Post(postProps);
  };

  const instagramAccountFailureCallback = (message) => {
    showToast(message, 'e');
    setLoaderReplies(false);
  };
  const cleanupListener = () => {
    if (messageListenerRef.current) {
      window.removeEventListener('message', messageListenerRef.current, false);
      messageListenerRef.current = null; // Reset the ref
    }
  };
  const getInstagramAccounts = (code) => {
    let instagramForm = {
      code,
    };
    let postProps = {
      url: integrateModuleURL.getInstagramAccountsFromToken,
      body: instagramForm,
      successCallback: instagramAccountSuccessCallback,
      failureCallback: instagramAccountFailureCallback,
    };
    HttpServices.Post(postProps);
  };
  const instagramIntegrationSuccessCallback = (data, message) => {
    CommonHelper.EnsureConversionFactorFlag(CommonHelper.ConversionFlagList.FIRST_SOCIAL_ACCOUNT_CONNECTED,"INSTAGRAM")
    setLoading(false);
    showToast(message, 's');
    handleClose();
  };
  const instagramIntegrationFailureCallback = (message) => {
    setLoading(false);
    if (!showResellerLimitDialog(message)) {
      message && showToast(message, 'e');
    }
    handleClose();
  };
  const handleSubmitInstagramAccounts = () => {
    setLoading(true);
    
    let instagramForm = {
      id: profileId,
      accounts: selectedAccounts,
    };
    let postProps = {
      url: integrateModuleURL.integrateInstagram,
      body: instagramForm,
      successCallback: instagramIntegrationSuccessCallback,
      failureCallback: instagramIntegrationFailureCallback,
    };
    HttpServices.Post(postProps);
  };
  const handleAccounts = (accountId) => {
    let selectedAccountList = [...selectedAccounts];
    let index = selectedAccountList.findIndex((a) => a.id === accountId);
    if (index >= 0) selectedAccountList.splice(index, 1);
    else {
      let selectedPage = accounts.find((a) => a.id === accountId);
      selectedAccountList.push(selectedPage);
    }
    setSelectedAccounts(selectedAccountList);
  };

  const checkAuthoCodeReceivedFromFacebook = () => {
    if (isCustomDomain) {
      const handleMessage = (event) => {
        const { type, code } = event.data;
        if (type === 'fb_auth_code' && code && !isProcessing) {
          isProcessing = true;
          cleanupListener();
          clearInterval(intervalId); // Stop polling
          getInstagramAccounts(code); // Process the code
        }
      };

      if (!messageListenerRef.current) {
        window.addEventListener('message', handleMessage, false);
        messageListenerRef.current = handleMessage; // Save the reference
      }
    } else {
      const code = localStorage.getItem('fb_autho_code');
      const error = localStorage.getItem('fb_error');
      if (code) {
        localStorage.removeItem('fb_autho_code');
        clearInterval(intervalId);
        getInstagramAccounts(code);
      } else if (error) {
        localStorage.removeItem('fb_error');
        clearInterval(intervalId);
        showToast(error, 'e');
        handleClose();
      }
    }
  };

  const handleConnectInstagram = () => {
    setLoadSdk(true);
  };

  const handleClose = () => {
    cleanupListener();
    props.handleClose();
  };

  const checkAccountIsIntegrated = (account) => {
    let isChecked = false;
    if (account.is_integrated) isChecked = true;
    else {
      let selectedAccountList = [...selectedAccounts];
      if (selectedAccountList && selectedAccountList.length > 0) {
        let index = selectedAccountList.findIndex((a) => a.id === account.id);
        if (index >= 0) isChecked = true;
      }
    }
    return isChecked;
  };
  const SmallAvatar = styled(Avatar)(({ theme }) => ({
    width: 20,
    height: 20,
    backgroundColor: '#fff',
  }));
  return (
    <>
      {isAuthorizationModalOpen && (
        <InstagramAuthorizationModal handleConnectInstagram={handleConnectInstagram} handleClose={handleClose} />
      )}
      {isInstaAccountModalOpen ? (
        <Dialog onClose={handleClose} open={isInstaAccountModalOpen} fullWidth>
          <DialogTitle>{translate('integration.instagram.accounts')}</DialogTitle>
          <DialogContent dividers>
            <div className="l2s-space-between">
              <Box
                sx={{
                  minHeight: '220px',
                }}
              >
                {accounts && accounts.length > 0 ? (
                  <>
                    <List>
                      {accounts.map((a) => {
                        return (
                          <ListItem
                            secondaryAction={
                              <Checkbox
                                edge="end"
                                value={a.id}
                                checked={checkAccountIsIntegrated(a)}
                                onClick={
                                  isNoAccountForIntegrate
                                    ? null
                                    : () => {
                                        handleAccounts(a.id);
                                      }
                                }
                                disabled={a.is_integrated}
                              />
                            }
                            disablePadding
                          >
                            <ListItemButton
                              onClick={
                                isNoAccountForIntegrate
                                  ? null
                                  : () => {
                                      handleAccounts(a.id);
                                    }
                              }
                              disabled={a.is_integrated}
                            >
                              <ListItemAvatar>
                                <Badge
                                  overlap="circular"
                                  anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                                  badgeContent={<SmallAvatar alt="" src={instagram} />}
                                >
                                  <Avatar
                                    src={a.profile_picture_url ? a.profile_picture_url : a.name || a.id}
                                    alt={a.name ? a.name : a.id}
                                    style={{ color: '#ffffff' }}
                                  />
                                </Badge>
                              </ListItemAvatar>
                              <ListItemText primary={a.name} />
                            </ListItemButton>
                          </ListItem>
                        );
                      })}
                    </List>
                    {pagination !== '' && (
                      <Box sx={{ textAlign: 'center', marginRight: '12rem !important' }}>
                        {loaderReplies ? (
                          <ThreeDotLoader />
                        ) : (
                          <Typography
                            variant="body1"
                            sx={{
                              fontWeight: 700,
                              textDecoration: 'underline',
                              cursor: 'pointer',
                              color: theme.palette.grey[500],
                            }}
                            onClick={fetchNextPagesFromServer}
                          >
                            {translate('integration.next_pages')}
                          </Typography>
                        )}
                      </Box>
                    )}
                    {isNoAccountForIntegrate && (
                      <Typography
                        sx={{
                          color: 'red',
                          fontSize: '12px',
                          marginTop: '10px',
                        }}
                      >
                        {translate('common.accounts_integrated')}
                      </Typography>
                    )}
                  </>
                ) : (
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      textAlign: 'center',
                      padding: '20px',
                    }}
                  >
                    <Typography sx={{ color: 'red', marginBottom: '10px' }}>
                      {translate('integration.instagram.no_facebook_pages_connected_to_instagram')}
                    </Typography>

                    {(!isCustomDomain || isPortalAdmin) && (isMobile ? (
                      <Box
                        sx={{
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          justifyContent: 'center',
                          textAlign: 'center',
                          padding: '20px',
                        }}
                      >
                        {/* First line: User Guide */}
                        <Typography sx={{ fontSize: '14px', color: 'gray', marginBottom: '10px' }}>
                          {translate('integration.instagram.read_our')}
                          <Link
                            href="https://brand2social.com/user-guides/setting-up-instagram-on-brand2social/"
                            target="_blank"
                            rel="noopener noreferrer"
                            sx={{
                              color: 'blue',
                              textDecoration: 'none',
                              fontWeight: 'bold',
                              marginLeft: '5px',
                              marginRight: '5px',
                            }}
                          >
                            {translate('integration.instagram.user_guide')}
                          </Link>
                          {translate('integration.instagram.step_by_step_integration')}
                        </Typography>

                        <Typography sx={{ fontSize: '14px', color: 'gray' }}>
                          {translate('integration.instagram.watch_the_video')}
                        </Typography>

                        {(!isCustomDomain || isPortalAdmin) && (
                          <Button
                            variant="outlined"
                            startIcon={<YouTubeIcon />}
                            onClick={() => window.open('https://www.youtube.com/watch?v=GkrXcPFJ57U', '_blank')}
                            color="primary"
                          >
                            {translate('common.tutorial')}
                          </Button>
                        )}
                      </Box>
                    ) : (
                      <Box
                        sx={{
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          justifyContent: 'center',
                          textAlign: 'center',
                          padding: '20px',
                        }}
                      >
                        {/* First line: User Guide */}
                        <Typography sx={{ fontSize: '14px', color: 'gray', marginBottom: '10px' }}>
                          {translate('integration.instagram.read_our')}
                          <Link
                            href="https://brand2social.com/user-guides/setting-up-instagram-on-brand2social/"
                            target="_blank"
                            rel="noopener noreferrer"
                            sx={{
                              color: 'blue',
                              textDecoration: 'none',
                              fontWeight: 'bold',
                              marginLeft: '5px',
                              marginRight: '5px',
                            }}
                          >
                            {translate('integration.instagram.user_guide')}
                          </Link>
                          {translate('integration.instagram.step_by_step_integration')}
                        </Typography>

                        {/* Second line: Video tutorial */}
                        {(!isCustomDomain || isPortalAdmin) && (
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <Typography sx={{ fontSize: '14px', color: 'gray' }}>
                              {translate('integration.instagram.watch_the_video')}
                            </Typography>
                            <Button
                              variant="outlined"
                              startIcon={<YouTubeIcon />}
                              onClick={() => window.open('https://www.youtube.com/watch?v=GkrXcPFJ57U', '_blank')}
                              color="primary"
                            >
                              {translate('common.tutorial')}
                            </Button>
                          </Box>
                        )}
                      </Box>
                    ))}
                  </Box>
                )}
              </Box>
              {isCustomDomain && <CustomDomainRedirectIframe serviceName="instagram" />}
            </div>
          </DialogContent>
          <DialogActions>
            <Button color="error" variant="outlined" onClick={handleClose}>
              {translate('common.cancel')}
            </Button>
            {accounts && accounts.length > 0 && !isNoAccountForIntegrate && (
              <LoadingButton
                variant="contained"
                disabled={selectedAccounts.length === 0}
                loading={isLoading}
                autoFocus
                onClick={handleSubmitInstagramAccounts}
              >
                {translate('common.submit')}
              </LoadingButton>
            )}
          </DialogActions>
        </Dialog>
      ) : null}
      {isLoadSdk && <LoadFacebookSdk />}
    </>
  );
};
export default InstagramIntegration;
